import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { tap } from "rxjs/operators";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { Document, DocumentQuery, DocumentType } from "./documents";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "bottom";
  url = environment.url;

  constructor(
    private http: HttpClient,
    private toast: MatSnackBar,
    private _translateService: TranslateService,
  ) {}

  /**
   * Pobiera pojedynczy szablon dokumentu na podstawie filtra (np. języka, typu).
   * @since 09.07.2026
   */
  getSingleDocument(query: DocumentQuery) {
    const params = {
      ...query,
    };

    return this.http.get<Document>(`${this.url}/documents/single`, { params });
  }

  /**
   * Tworzy nowy szablon dokumentu.
   * @since 09.07.2026
   */
  createDocument(payload: Document) {
    return this.http.post<Document>(`${this.url}/documents`, payload).pipe(
      tap(() => {
        this.toast.open(
          this._translateService.instant("Pomyślnie utworzono dokument."),
          this._translateService.instant("Zamknij"),
          {
            duration: 2000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          },
        );
      }),
    );
  }

  /**
   * Aktualizuje istniejący szablon dokumentu.
   * @since 09.07.2026
   */
  updateDocument(documentId: string, payload: Document) {
    return this.http
      .patch<Document>(`${this.url}/documents/single/${documentId}`, payload)
      .pipe(
        tap(() => {
          this.toast.open(
            this._translateService.instant("Pomyślnie wprowadzono zmiany."),
            this._translateService.instant("Zamknij"),
            {
              duration: 2000,
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
            },
          );
        }),
      );
  }
}
